export default __webpack_public_path__ + "static/card-4-1112793bca8fc3cacf3c6f9d114405e3.png";